import './LibraryPager.css';

type LibraryPagerProps = {
  page: number;
  pageSize: number;
  total: number;
  /** Extra context after "Page X of Y · N per page", e.g. "sorted by ship date". */
  note?: string | null;
  onPageChange: (page: number) => void;
  /** Names the navigation landmark, e.g. "Transfers pages". */
  ariaLabel: string;
};

/**
 * Previous/Next paging for a server-paged library with a fixed page size (the server caps pages,
 * so there is no page-size picker; Maintenance lists keep MaintenanceListPagination for theirs).
 */
export default function LibraryPager({ page, pageSize, total, note, onPageChange, ariaLabel }: LibraryPagerProps) {
  if (total <= 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(Math.max(1, page), totalPages);
  const summary = [
    `Page ${current.toLocaleString()} of ${totalPages.toLocaleString()}`,
    `${pageSize} per page`,
    note || null,
  ].filter(Boolean).join(' · ');
  return (
    <nav className="library-pager" aria-label={ariaLabel}>
      <span className="library-pager__summary text-sm fg-muted" aria-live="polite">{summary}</span>
      <div className="library-pager__buttons">
        <button type="button" className="btn xs" onClick={() => onPageChange(current - 1)} disabled={current <= 1}>
          Previous
        </button>
        <button type="button" className="btn xs" onClick={() => onPageChange(current + 1)} disabled={current >= totalPages}>
          Next
        </button>
      </div>
    </nav>
  );
}
